import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/** The keys the analytics answers are cached under; the app's hooks read them from here. */
export const REPORT_QUERY_KEY = "reportQuery";
export const REPORT_MAP_QUERY_KEY = "reportMap";
export const REPORT_RECORDS_QUERY_KEY = "reportRecords";

/**
 * Refetches every analytics answer on screen (numbers, charts, floor maps,
 * row lists) after the data behind them changed, such as a desk's
 * assignment edited from a map.
 */
export const useInvalidateReportAnswers = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    for (const key of [
      REPORT_QUERY_KEY,
      REPORT_MAP_QUERY_KEY,
      REPORT_RECORDS_QUERY_KEY
    ]) {
      await queryClient.invalidateQueries({ queryKey: [key] });
    }
  }, [queryClient]);
};
